import React, { useState } from 'react';

const BHK_OPTIONS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

const SortPopup = ({
  isOpen,
  onOptionChange,
  setIsOpen,
  handleSortOrderChange,
  selectedBhk = [],
  toggleBhk,
  clearBhk,
}) => {
    const [selectedOption, setSelectedOption] = useState('');

    const handleOptionChange = (str,e) => {
      if(selectedOption!== e.target.value||selectedOption===''){
        
        setSelectedOption(e.target.value);
        handleSortOrderChange(str)
    }
      else{setSelectedOption('')
    //   onOptionChange(e.target.value);
      handleSortOrderChange('')
    }
      

    };
  
    

  return (
    <div className="relative">
      {isOpen && (
        <div className="fixed  inset-0 font-jt flex h-screen items-center justify-center z-[100000] backdrop-blur-sm bg-black bg-opacity-50">
          <div className='bg-white flex flex-col p-4 w-[90vw] space-y-4 rounded-2xl max-h-[85vh] overflow-y-auto'>
          <div className="w-full  flex items-end text-end justify-end text-black">
          <button  onClick={()=>setIsOpen(!isOpen)}>
            <svg
              width="25"
              height="25"
              viewBox="0 0 34 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.0001 1.41666C13.918 1.41666 10.9051 2.3306 8.34245 4.04292C5.77979 5.75524 3.78243 8.18902 2.60297 11.0365C1.4235 13.884 1.1149 17.0173 1.71618 20.0401C2.31747 23.063 3.80164 25.8397 5.98101 28.0191C8.16038 30.1984 10.9371 31.6826 13.9599 32.2839C16.9828 32.8852 20.1161 32.5766 22.9636 31.3971C25.8111 30.2176 28.2448 28.2203 29.9572 25.6576C31.6695 23.095 32.5834 20.0821 32.5834 17C32.5834 12.867 30.9416 8.90335 28.0192 5.98091C25.0967 3.05847 21.133 1.41666 17.0001 1.41666ZM23.6683 21.6651C23.8036 21.7958 23.9116 21.9521 23.9858 22.1249C24.0601 22.2978 24.0991 22.4837 24.1008 22.6718C24.1024 22.8599 24.0666 23.0464 23.9953 23.2205C23.9241 23.3946 23.8189 23.5528 23.6859 23.6858C23.5529 23.8188 23.3947 23.924 23.2206 23.9952C23.0465 24.0665 22.86 24.1023 22.6719 24.1007C22.4837 24.099 22.2979 24.06 22.125 23.9857C21.9522 23.9115 21.7959 23.8035 21.6652 23.6682L17.0001 19.0032L12.335 23.6682C12.2043 23.8035 12.048 23.9115 11.8752 23.9857C11.7023 24.06 11.5164 24.099 11.3283 24.1007C11.1402 24.1023 10.9537 24.0665 10.7796 23.9952C10.6055 23.924 10.4473 23.8188 10.3143 23.6858C10.1813 23.5528 10.0761 23.3946 10.0048 23.2205C9.93361 23.0464 9.89777 22.8599 9.8994 22.6718C9.90103 22.4837 9.94011 22.2978 10.0144 22.1249C10.0886 21.9521 10.1965 21.7958 10.3318 21.6651L14.9969 17L10.3318 12.3349C10.1965 12.2042 10.0886 12.0479 10.0144 11.8751C9.94011 11.7022 9.90103 11.5163 9.8994 11.3282C9.89777 11.1401 9.93361 10.9536 10.0048 10.7795C10.0761 10.6054 10.1813 10.4472 10.3143 10.3142C10.4473 10.1812 10.6055 10.076 10.7796 10.0047C10.9537 9.93351 11.1402 9.89767 11.3283 9.8993C11.5164 9.90094 11.7023 9.94002 11.8752 10.0143C12.048 10.0885 12.2043 10.1964 12.335 10.3317L17.0001 14.9968L21.6652 10.3317C21.7959 10.1964 21.9522 10.0885 22.125 10.0143C22.2979 9.94002 22.4837 9.90094 22.6719 9.8993C22.86 9.89767 23.0465 9.93351 23.2206 10.0047C23.3947 10.076 23.5529 10.1812 23.6859 10.3142C23.8189 10.4472 23.9241 10.6054 23.9953 10.7795C24.0666 10.9536 24.1024 11.1401 24.1008 11.3282C24.0991 11.5163 24.0601 11.7022 23.9858 11.8751C23.9116 12.0479 23.8036 12.2042 23.6683 12.3349L19.0033 17L23.6683 21.6651Z"
                fill="#D00808"
              />
            </svg>
          </button>
          </div>
          <div className="px-4 py-2">
            <div className="text-2xl font-semibold mb-3">Filter by BHK</div>
            <div className="space-y-2">
              {BHK_OPTIONS.map((value) => (
                <label key={value} className="flex flex-row items-center text-xl gap-3">
                  <input
                    type="checkbox"
                    checked={selectedBhk.includes(value)}
                    onChange={() => toggleBhk?.(value)}
                    className="w-5 h-5 accent-black"
                  />
                  <span>{value === 10 ? "10+ BHK" : `${value} BHK`}</span>
                </label>
              ))}
            </div>
            {selectedBhk.length > 0 && (
              <button
                type="button"
                className="mt-3 text-base font-semibold text-[#717171]"
                onClick={() => clearBhk?.()}
              >
                Clear BHK filter
              </button>
            )}
          </div>
          <label className="flex flex-row px-4 py-2   text-2xl">
            <input
              type="radio"
              name="option"
              value="Low to High"
              checked={selectedOption === 'Low to High'}
              onClick={(e)=>handleOptionChange("asc",e)}
              
            />
           <div className='flex flex-row items-center ml-2'>
            <svg
            width="22"
            height="22"
            viewBox="0 0 25 25"
            fill="none"
            className="mr-2"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.75 3.75C3.05965 3.75 2.5 4.30965 2.5 5C2.5 5.69035 3.05965 6.25 3.75 6.25H17.5C18.1904 6.25 18.75 5.69035 18.75 5C18.75 4.30965 18.1904 3.75 17.5 3.75H3.75Z"
              fill="#020202"
            />
            <path
              d="M3.75 8.75C3.05965 8.75 2.5 9.30965 2.5 10C2.5 10.6904 3.05965 11.25 3.75 11.25H12.5C13.1904 11.25 13.75 10.6904 13.75 10C13.75 9.30965 13.1904 8.75 12.5 8.75H3.75Z"
              fill="#020202"
            />
            <path
              d="M3.75 13.75C3.05965 13.75 2.5 14.3096 2.5 15C2.5 15.6904 3.05965 16.25 3.75 16.25H8.75C9.44035 16.25 10 15.6904 10 15C10 14.3096 9.44035 13.75 8.75 13.75H3.75Z"
              fill="#020202"
            />
            <path
              d="M18.75 10C18.75 9.30965 18.1904 8.75 17.5 8.75C16.8096 8.75 16.25 9.30964 16.25 10V16.9823L14.6339 15.3661C14.1457 14.878 13.3542 14.878 12.8661 15.3661C12.378 15.8542 12.378 16.6458 12.8661 17.1339L16.6161 20.8839C16.8505 21.1182 17.1685 21.25 17.5 21.25C17.8315 21.25 18.1495 21.1182 18.3839 20.8839L22.1339 17.1339C22.622 16.6458 22.622 15.8542 22.1339 15.3661C21.6457 14.878 20.8542 14.878 20.3661 15.3661L18.75 16.9823V10Z"
              fill="#020202"
            />
          </svg>
            <div>Price (Low to High)</div>
            </div>
          </label>
          <label className="flex flex-row px-4 py-2 text-2xl">
            <input
              type="radio"
              name="option"
              value="Customer Ratings"
              checked={selectedOption === 'Customer Ratings'}
              onClick={(e)=>handleOptionChange("rating",e)}
              
            />
            <div className='flex flex-row items-center ml-2'>
            <svg
            width="22"
            height="22"
            viewBox="0 0 25 25"
            fill="none"
            className="mr-2"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.75 3.75C3.05965 3.75 2.5 4.30965 2.5 5C2.5 5.69035 3.05965 6.25 3.75 6.25H17.5C18.1904 6.25 18.75 5.69035 18.75 5C18.75 4.30965 18.1904 3.75 17.5 3.75H3.75Z"
              fill="#020202"
            />
            <path
              d="M3.75 8.75C3.05965 8.75 2.5 9.30965 2.5 10C2.5 10.6904 3.05965 11.25 3.75 11.25H12.5C13.1904 11.25 13.75 10.6904 13.75 10C13.75 9.30965 13.1904 8.75 12.5 8.75H3.75Z"
              fill="#020202"
            />
            <path
              d="M3.75 13.75C3.05965 13.75 2.5 14.3096 2.5 15C2.5 15.6904 3.05965 16.25 3.75 16.25H8.75C9.44035 16.25 10 15.6904 10 15C10 14.3096 9.44035 13.75 8.75 13.75H3.75Z"
              fill="#020202"
            />
            <path
              d="M18.75 10C18.75 9.30965 18.1904 8.75 17.5 8.75C16.8096 8.75 16.25 9.30964 16.25 10V16.9823L14.6339 15.3661C14.1457 14.878 13.3542 14.878 12.8661 15.3661C12.378 15.8542 12.378 16.6458 12.8661 17.1339L16.6161 20.8839C16.8505 21.1182 17.1685 21.25 17.5 21.25C17.8315 21.25 18.1495 21.1182 18.3839 20.8839L22.1339 17.1339C22.622 16.6458 22.622 15.8542 22.1339 15.3661C21.6457 14.878 20.8542 14.878 20.3661 15.3661L18.75 16.9823V10Z"
              fill="#020202"
            />
          </svg>
            <div>Customer Ratings</div>
            </div>
          </label>
          </div>
        </div>
      )}
    </div>
  );
};

export default SortPopup;
